import React, { useEffect, useState } from 'react';
import { Button } from 'components/componentsPresfor';
import AttestationValidationEnqueteFonciere, {
  AnnexeAttestationValidation,
} from '.';
import Sidebar4 from 'components/componentsPresfor/SidebarPresfor';
import { Text } from 'components/componentsPresfor';
import secureStorage from 'hooks/secureStorage';
import { dtvAttestationValidbyenquete } from 'service/api-presfor';

const PageAttestationValidationEnqueteFonciere = () => {
  const enquete = secureStorage.getItem('enquete_courante');
  const enqueteObj = JSON.parse(enquete);

  return (
    <>
      <div
        className="flex flex-col items-start justify-start w-auto mx-auto overflow-auto bg-no-repeat bg-cover bg-white-A700 font-inter sm:w-full md:w-full"
        style={{ backgroundImage: "url('images/img_psfchome.png')" }}
      >
        <div className="flex md:flex-col flex-row gap-4 h-auto md:h-auto items-start justify-start w-full p-4">
          <Sidebar4
            className="!sticky !w-[263px] bg-white-A700 flex h-screen md:hidden justify-start overflow-auto md:px-5 top-[0]"
            activeclassdelimitation="common-pointer cursor-pointer font-inter leading-[normal] mt-2.5 mx-auto rounded-sm text-center text-xs w-[223px]"
            activeclrdelimitation="teal_300"
          />

          <div className="flex flex-1 flex-col items-center justify-start w-full">
            <div className="flex flex-col gap-4 items-start justify-start p-6 sm:px-5 w-full">
              <div className="flex flex-col gap-3 items-start justify-start w-full">
                <Text
                  className="text-2xl md:text-[22px] text-black-900 sm:text-xl w-auto"
                  size="txtInterSemiBold"
                >
                  PRESFOR
                </Text>
                <Text
                  className="text-black-900 text-center text-sm w-auto"
                  size="txtInterMedium"
                >
                  <span className="text-black-900 font-inter font-medium">
                    Enquête :{' '}
                  </span>
                  <span className="text-black-900 font-inter font-bold">
                    {enqueteObj.numero_enquete}
                  </span>
                  <span className="text-black-900 font-inter font-medium">
                    {' '}
                  </span>
                </Text>
              </div>
            </div>
            <div className="bg-white-A700 flex flex-col items-center justify-center sm:px-5 px-8 py-5 rounded w-full">
              <div className="flex flex-col gap-[5px] justify-start w-[60%]">
                <AttestationValidationTabs />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const AttestationValidationTabs = () => {
  const enquete = secureStorage.getItem('enquete_courante');
  const enqueteObj = JSON.parse(enquete);
  const [activeTab, setActiveTab] = useState('attestation');
  const [req, setReq] = useState(null);
  useEffect(() => {
   dtvAttestationValidbyenquete(enqueteObj?.numero_enquete).then((res) => {
      if (res?.data?.data?.dtv_attestation_validation) {
        setReq(res?.data?.data?.dtv_attestation_validation);
      }
    });
  }, []);
  return (
    <div>
      <div>
        {activeTab === 'attestation' ? (
          <AttestationValidationEnqueteFonciere
            setActiveTab={setActiveTab}
            setReq={setReq}
          />
        ) : (
          <AnnexeAttestationValidation
            setActiveTab={setActiveTab}
            createData={req}
          />
        )}
      </div>
    </div>
  );
};

export default PageAttestationValidationEnqueteFonciere;
